
__webpack_require__.debugRequireIds = {
	"-!./debug-require.cjs": 2800,
	"-!jquery": 49949,
	"./debug-require.cjs": 45082,
	"./src/base_page_params.ts": 73752,
	"./src/blueslip.ts": 36618,
	"./src/blueslip_stacktrace.ts": 64676,
	"./src/bot_types.ts": 85609,
	"./src/bundles/common.ts": 91719,
	"./src/bundles/legacy_portico_bundle.ts": 59249,
	"./src/csrf.ts": 90758,
	"./src/portico/communities.ts": 4800,
	"./src/portico/google-analytics.ts": 32055,
	"./src/portico/header.ts": 19036,
	"./src/portico/portico_modals.ts": 13542,
	"./src/portico/tippyjs.ts": 24320,
	"./src/realm_user_settings_defaults.ts": 87584,
	"./src/sentry.ts": 44627,
	"./src/state_data.ts": 59050,
	"./src/stream_types.ts": 57358,
	"./src/types.ts": 11043,
	"./src/user_settings.ts": 98931,
	"./src/user_status_types.ts": 10258,
	"./styles/portico/integrations.css": 90450,
	"./styles/portico/legacy_landing_page.css": 14838,
	"./templates/blueslip_stacktrace.hbs": 24075,
	"core-js/modules/es.array.push.js": 64755,
	"core-js/modules/es.iterator.constructor.js": 94178,
	"core-js/modules/es.iterator.find.js": 58471,
	"core-js/modules/es.iterator.map.js": 64792,
	"core-js/modules/es.json.stringify.js": 99811,
	"core-js/modules/esnext.json.parse.js": 22862,
	"core-js/modules/web.url-search-params.delete.js": 89584,
	"core-js/modules/web.url-search-params.has.js": 17535,
	"core-js/modules/web.url-search-params.size.js": 10418,
	"error-stack-parser": 69363,
	"ga-gtag": 78406,
	"handlebars/runtime.js": 81942,
	"jquery": 51454,
	"micromodal": 98476,
	"minimalistic-assert": 45185,
	"source-map": 68068,
	"stackframe": 36854,
	"stacktrace-gps": 14021,
	"tippy.js": 99947,
	"tippy.js/dist/tippy.css": 25957,
	"zod/mini": 59741
};